import apiClient from './api';

export const getModulesByDomain = async (email: string) => {
    const response = await apiClient.get(`/module/email/${email}`);
    return response.data;
}

export const getModulesByOrganization = async (organizationID: number) => {
    const response = await apiClient.get(`/module/organization/${organizationID}`);
    return response.data;
}

export const getModule = async (moduleID: number) => {
    const response = await apiClient.get(`/module/${moduleID}`);
    return response.data;
}

export const updateModule = async (moduleID: number, module: any) => {
    const response = await apiClient.put(`/module/${moduleID}`, module);
    return response.data;
}

export const getModulesNeedingRefresh = async (moduleIDs: number[], sinceUnixMs: number): Promise<{ flaggedModuleIDs: number[] }> => {
    const params = new URLSearchParams();
    moduleIDs.forEach(id => params.append('moduleIDs', id.toString()));
    params.append('sinceUnixMs', sinceUnixMs.toString());
    const response = await apiClient.get(`/module/needs-refresh?${params}`);
    return response.data;
}

